import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { type CodeSnippetElement } from '../../types/aha-editor';
import { isCodeSnippetElement } from '../../types/guards';
import { isHTMLElementNode } from '../helpers/serializerHelpers';

class SerializerCodeSnippet extends Serializer {
  static deserialize({
    el,
    next,
    markAttributes,
  }: DeserializeArguments): CodeSnippetElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'code') return;

    return {
      type: 'code-snippet',
      children: next(el.childNodes, markAttributes),
    };
  }

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isCodeSnippetElement(node)) return;

    return <code>{children}</code>;
  }
}

export default SerializerCodeSnippet;
